/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBed = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 2v9h2v11h-5.72l-1-3H7.721l-1 3H1V11h2V2zm0 11H3v7h2.28l1-3h11.441l1 3H21zm-2-9H5v7h2V9.001A3.005 3.005 0 0 1 10 6h4c1.654 0 3 1.347 3 3.001V11h2zm-5 4h-4c-.55 0-1 .449-1 1.001V11h6V9.001C15 8.449 14.551 8 14 8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBed as Bed };
